import React from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import YouKassaComponent from '../widgets/ukassa.jsx'

class ByuComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      pageContent: '',
    };
  }

   getBrowserLanguage  () {
    //const language = navigator.language.split(/[-_]/)[0]; // Language without region code
    const language = this.props.intl.locale.split(/[-_]/)[0];
    return language ? language : 'en'; // Фолбэк на английский, если язык не поддерживается
  };

  componentDidMount() {
    this.props.eventToGAnalitycs("byu_show",{option: this.props.paymentOption});
   
  }

 

  render() {
    const { pageContent } = this.state;

    return (
      <div className='buy-overlay'>
        <div className='buy-container'>
          
          <div className="cancel">
            <a href="#" onClick={e => {e.preventDefault(); this.props.onCancel();}}><i className="material-icons gray">close</i></a>
          </div>
          <div>
            <h2>
            <FormattedMessage id="choosetarif" defaultMessage="Choose payment option"
                    description="Choose payment option" />
            </h2>
          </div>

          <div>
            <YouKassaComponent 
                tinode = {this.props.tinode}
                paymentOption= {this.props.paymentOption}
                confirmPayService = {this.props.confirmPayService}
                confirmPayToken = {this.props.confirmPayToken}
                onUpdateTokensBalance = {this.props.onUpdateTokensBalance}
                intl={this.props.intl}
                eventToGAnalitycs = {this.props.eventToGAnalitycs}
            />

           
          </div>

          
        </div>
      </div>
    );
  }
}

export default ByuComponent;
